// Action Types

export const actionTypes = {
  UPDATE_COUNTER_CLICKED_TIME: 'UPDATE_COUNTER_CLICKED_TIME'
}

// Action Creators

const updateCounterClickedTime = parameters => ({
  type: actionTypes.UPDATE_COUNTER_CLICKED_TIME,
  payload: parameters
})

export const actionCreators = {
  updateCounterClickedTime
}



// WEBPACK FOOTER //
// ./src/store/actions/accessory.js